import React from 'react';
import PropTypes from 'prop-types';
import { patientCCMStatusPresenter, patientStatusPresenter } from 'utils';
import UpdatedBy from './updatedBy';

const StatusLog = ({ patientStatusLog, type = 'RPM' }) => {
  const statusPresenter = (status, statusType) => {
    if (statusType === 'CCM') {
      return patientCCMStatusPresenter(status) || '';
    }
    return patientStatusPresenter(status) || '';
  };

  const firstName = patientStatusLog.patient?.firstName || '';
  const oldValue = statusPresenter(patientStatusLog.oldValue, type);
  const newValue = statusPresenter(patientStatusLog.newValue, type);

  return (
    <div>
      <div>
        {firstName}'s status changed
        {oldValue && (
          <div>
            From: <strong>{oldValue}</strong>
          </div>
        )}
        <div>
          To: <strong>{newValue}</strong>
        </div>
      </div>
      <UpdatedBy updatedBy={patientStatusLog.updatedByLogin} />
    </div>
  );
};

StatusLog.propTypes = {
  patientStatusLog: PropTypes.shape().isRequired,
  type: PropTypes.oneOf(['RPM', 'CCM']),
};

export default StatusLog;
